import { NameAddrHeader } from "../../name-addr-header.js";
import { URI } from "../../uri.js";

// Generated by peggy v. 1.2.0 (ts-pegjs plugin v. 1.2.2 )
//
// https://peggyjs.org/   https://github.com/metadevpro/ts-pegjs

export interface IFilePosition {
  offset: number;
  line: number;
  column: number;
}

export interface IFileRange {
  start: IFilePosition;
  end: IFilePosition;
  source: string;
}

export interface ILiteralExpectation {
  type: "literal";
  text: string;
  ignoreCase: boolean;
}

export interface IClassParts extends Array<string | IClassParts> {}

export interface IClassExpectation {
  type: "class";
  parts: IClassParts;
  inverted: boolean;
  ignoreCase: boolean;
}

export interface IAnyExpectation {
  type: "any";
}

export interface IEndExpectation {
  type: "end";
}

export interface IOtherExpectation {
  type: "other";
  description: string;
}

export type Expectation = ILiteralExpectation | IClassExpectation | IAnyExpectation | IEndExpectation | IOtherExpectation;

function peg$padEnd(str: string, targetLength: number, padString: string) {
  padString = padString || ' ';
  if (str.length > targetLength) {
    return str;
  }
  targetLength -= str.length;
  padString += padString.repeat(targetLength);
  return str + padString.slice(0, targetLength);
}

export class SyntaxError extends Error {
  public static buildMessage(expected: Expectation[], found: string | null) {
    function hex(ch: string): string {
      return ch.charCodeAt(0).toString(16).toUpperCase();
    }

    function literalEscape(s: string): string {
      return s
        .replace(/\\/g, "\\\\")
        .replace(/"/g,  "\\\"")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,            (ch) => "\\x0" + hex(ch) )
        .replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x"  + hex(ch) );
    }

    function classEscape(s: string): string {
      return s
        .replace(/\\/g, "\\\\")
        .replace(/\]/g, "\\]")
        .replace(/\^/g, "\\^")
        .replace(/-/g,  "\\-")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,            (ch) => "\\x0" + hex(ch) )
        .replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x"  + hex(ch) );
    }

    function describeExpectation(expectation: Expectation) {
      switch (expectation.type) {
        case "literal":
          return "\"" + literalEscape(expectation.text) + "\"";
        case "class":
          const escapedParts = expectation.parts.map((part) => {
            return Array.isArray(part)
              ? classEscape(part[0] as string) + "-" + classEscape(part[1] as string)
              : classEscape(part);
          });

          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        case "any":
          return "any character";
        case "end":
          return "end of input";
        case "other":
          return expectation.description;
      }
    }

    function describeExpected(expected1: Expectation[]) {
      const descriptions = expected1.map(describeExpectation);
      let i: number;
      let j: number;

      descriptions.sort();

      if (descriptions.length > 0) {
        for (i = 1, j = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ")
            + ", or "
            + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found1: string | null) {
      return found1 ? "\"" + literalEscape(found1) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  }

  public message: string;
  public expected: Expectation[];
  public found: string | null;
  public location: IFileRange;
  public name: string;

  constructor(message: string, expected: Expectation[], found: string | null, location: IFileRange) {
    super();
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof (Object as any).setPrototypeOf === "function") {
      (Object as any).setPrototypeOf(this, SyntaxError.prototype);
    } else {
      (this as any).__proto__ = SyntaxError.prototype;
    }
    if (typeof (Error as any).captureStackTrace === "function") {
      (Error as any).captureStackTrace(this, SyntaxError);
    }
  }

  format(sources: { source: string; text: string }[]): string {
    let str = 'Error: ' + this.message;
    if (this.location) {
      let src: string[] | null = null;
      let k;
      for (k = 0; k < sources.length; k++) {
        if (sources[k].source === this.location.source) {
          src = sources[k].text.split(/\r\n|\n|\r/g);
          break;
        }
      }
      let s = this.location.start;
      let loc = this.location.source + ':' + s.line + ':' + s.column;
      if (src) {
        let e = this.location.end;
        let filler = peg$padEnd('', s.line.toString().length, ' ');
        let line = src[s.line - 1];
        let last = s.line === e.line ? e.column : line.length + 1;
        str += '\n --> ' + loc + '\n' + filler + ' |\n' + s.line + ' | ' + line + '\n' + filler + ' | ' +
          peg$padEnd('', s.column - 1, ' ') +
          peg$padEnd('', last - s.column, '^');
      } else {
        str += '\n at ' + loc;
      }
    }
    return str;
  }
}

function peg$parse(input: string, options?: IParseOptions) {
  options = options !== undefined ? options : {};

  const peg$FAILED: Readonly<any> = {};
  const peg$source = options.grammarSource;

  const peg$startRuleIndices: {[id: string]: number}  = { Contact: 119, Name_Addr_Header: 156, Record_Route: 176, Request_Response: 81, SIP_URI: 45, Subscription_State: 186, Supported: 191, Require: 182, Via: 194, absoluteURI: 84, Call_ID: 118, Content_Disposition: 130, Content_Length: 135, Content_Type: 136, CSeq: 146, displayName: 122, Event: 149, From: 151, host: 52, Max_Forwards: 154, Min_SE: 213, Proxy_Authenticate: 157, quoted_string: 40, Refer_To: 178, Replaces: 179, Session_Expires: 210, stun_URI: 217, To: 192, turn_URI: 223, uuid: 226, WWW_Authenticate: 209, challenge: 158, sipfrag: 230, Referred_By: 231 };
  let peg$startRuleIndex = 119;

  const peg$consts = [
    "\r\n",
    peg$literalExpectation("\r\n", false),
    /^[0-9]/,
    peg$classExpectation([["0", "9"]], false, false),
    /^[a-zA-Z]/,
    peg$classExpectation([["a", "z"], ["A", "Z"]], false, false),
    /^[0-9a-fA-F]/,
    peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false),
    /^[\0-\xFF]/,
    peg$classExpectation([["\0", "\xFF"]], false, false),
    /^["]/,
    peg$classExpectation(["\""], false, false),
    " ",
    peg$literalExpectation(" ", false),
    "\t",
    peg$literalExpectation("\t", false),
    /^[a-zA-Z0-9]/,
    peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"]], false, false),
    ";",
    peg$literalExpectation(";", false),
    "/",
    peg$literalExpectation("/", false),
    "?",
    peg$literalExpectation("?", false),
    ":",
    peg$literalExpectation(":", false),
    "@",
    peg$literalExpectation("@", false),
    "&",
    peg$literalExpectation("&", false),
    "=",
    peg$literalExpectation("=", false),
    "+",
    peg$literalExpectation("+", false),
    "$",
    peg$literalExpectation("$", false),
    ",",
    peg$literalExpectation(",", false),
    "-",
    peg$literalExpectation("-", false),
    "_",
    peg$literalExpectation("_", false),
    ".",
    peg$literalExpectation(".", false),
    "!",
    peg$literalExpectation("!", false),
    "~",
    peg$literalExpectation("~", false),
    "*",
    peg$literalExpectation("*", false),
    "'",
    peg$literalExpectation("'", false),
    "(",
    peg$literalExpectation("(", false),
    ")",
    peg$literalExpectation(")", false),
    "%",
    peg$literalExpectation("%", false),
    function(): any {return " "; },
    function(): any {return ':'; },
    /^[!-~]/,
    peg$classExpectation([["!", "~"]], false, false),
    /^[\x80-\uFFFF]/,
    peg$classExpectation([["\x80", "\uFFFF"]], false, false),
    /^[\x80-\xBF]/,
    peg$classExpectation([["\x80", "\xBF"]], false, false),
    /^[a-f]/,
    peg$classExpectation([["a", "f"]], false, false),
    "`",
    peg$literalExpectation("`", false),
    "<",
    peg$literalExpectation("<", false),
    ">",
    peg$literalExpectation(">", false),
    "\\",
    peg$literalExpectation("\\", false),
    "[",
    peg$literalExpectation("[", false),
    "]",
    peg$literalExpectation("]", false),
    "{",
    peg$literalExpectation("{", false),
    "}",
    peg$literalExpectation("}", false),
    function(): any {return "*"; },
    function(): any {return "/"; },
    function(): any {return "="; },
    function(): any {return "("; },
    function(): any {return ")"; },
    function(): any {return ">"; },
    function(): any {return "<"; },
    function(): any {return ","; },
    function(): any {return ";"; },
    function(): any {return ":"; },
    function(): any {return "\""; },
    /^[!-']/,
    peg$classExpectation([["!", "'"]], false, false),
    /^[*-[]/,
    peg$classExpectation([["*", "["]], false, false),
    /^[\]-~]/,
    peg$classExpectation([["]", "~"]], false, false),
    function(contents: any): any {
                            return contents; },
    /^[#-[]/,
    peg$classExpectation([["#", "["]], false, false),
    /^[\0-\t]/,
    peg$classExpectation([["\0", "\t"]], false, false),
    /^[\v-\f]/,
    peg$classExpectation([["\v", "\f"]], false, false),
    /^[\x0E-\x7F]/,
    peg$classExpectation([["\x0E", "\x7F"]], false, false),
    function(): any {
                            options = options || { data: {}};
                            options.data.uri = new URI(options.data.scheme, options.data.user, options.data.host, options.data.port);
                            delete options.data.scheme;
                            delete options.data.user;
                            delete options.data.host;
                            delete options.data.host_type;
                            delete options.data.port;
                          },
    function(): any {
                            options = options || { data: {}};
                            options.data.uri = new URI(options.data.scheme, options.data.user, options.data.host, options.data.port, options.data.uri_params, options.data.uri_headers);
                            delete options.data.scheme;
                            delete options.data.user;
                            delete options.data.host;
                            delete options.data.host_type;
                            delete options.data.port;
                            delete options.data.uri_params;

                            if (options.startRule === 'SIP_URI') { options.data = options.data.uri;}
                          },
    "sips",
    peg$literalExpectation("sips", true),
    "sip",
    peg$literalExpectation("sip", true),
    function(uri_scheme: any): any {
                        options = options || { data: {}};
                        options.data.scheme = uri_scheme; },
    function(): any {
                        options = options || { data: {}};
                        options.data.user = decodeURIComponent(text().slice(0, -1));},
    function(): any {
                        options = options || { data: {}};
                        options.data.password = text(); },
    function(): any {
                        options = options || { data: {}};
                        options.data.host = text();
                        return options.data.host; },
    function(): any {
                      options = options || { data: {}};
                      options.data.host_type = 'domain';
                      return text(); },
    /^[a-zA-Z0-9_\-]/,
    peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", "-"], false, false),
    /^[a-zA-Z0-9\-]/,
    peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "-"], false, false),
    function(): any {
                        options = options || { data: {}};
                        options.data.host_type = 'IPv6';
                        return text(); },
    "::",
    peg$literalExpectation("::", false),
    function(): any {
                      options = options || { data: {}};
                      options.data.host_type = 'IPv6';
                      return text(); },
    function(): any {
                        options = options || { data: {}};
                        options.data.host_type = 'IPv4';
                        return text(); },
    "25",
    peg$literalExpectation("25", false),
    /^[0-5]/,
    peg$classExpectation([["0", "5"]], false, false),
    "2",
    peg$literalExpectation("2", false),
    /^[0-4]/,
    peg$classExpectation([["0", "4"]], false, false),
    "1",
    peg$literalExpectation("1", false),
    /^[1-9]/,
    peg$classExpectation([["1", "9"]], false, false),
    function(port: any): any {
                        options = options || { data: {}};
                        port = parseInt(port.join(''));
                        options.data.port = port;
                        return port; },
    "transport=",
    peg$literalExpectation("transport=", true),
    "udp",
    peg$literalExpectation("udp", true),
    "tcp",
    peg$literalExpectation("tcp", true),
    "sctp",
    peg$literalExpectation("sctp", true),
    "tls",
    peg$literalExpectation("tls", true),
    function(transport: any): any {
                          options = options || { data: {}};
                          if(!options.data.uri_params) options.data.uri_params={};
                          options.data.uri_params['transport'] = transport.toLowerCase(); },
    "user=",
    peg$literalExpectation("user=", true),
    "phone",
    peg$literalExpectation("phone", true),
    "ip",
    peg$literalExpectation("ip", true),
    function(user: any): any {
                          options = options || { data: {}};
                          if(!options.data.uri_params) options.data.uri_params={};
                          options.data.uri_params['user'] = user.toLowerCase(); },
    "method=",
    peg$literalExpectation("method=", true),
    function(method: any): any {
                          options = options || { data: {}};
                          if(!options.data.uri_params) options.data.uri_params={};
                          options.data.uri_params['method'] = method; },
    "ttl=",
    peg$literalExpectation("ttl=", true),
    function(ttl: any): any {
                          options = options || { data: {}};
                          if(!options.data.params) options.data.params={};
                          options.data.params['ttl'] = ttl; },
    "maddr=",
    peg$literalExpectation("maddr=", true),
    function(maddr: any): any {
                          options = options || { data: {}};
                          if(!options.data.uri_params) options.data.uri_params={};
                          options.data.uri_params['maddr'] = maddr; },
    "lr",
    peg$literalExpectation("lr", true),
    function(): any {
                          options = options || { data: {}};
                          if(!options.data.uri_params) options.data.uri_params={};
                          options.data.uri_params['lr'] = undefined; },
    function(param: any, value: any): any {
                          options = options || { data: {}};
                          if(!options.data.uri_params) options.data.uri_params = {};
                          if (value === null){
                            value = undefined;
                          }
                          else {
                            value = value[1];
                          }
                          options.data.uri_params[param.toLowerCase()] = value;},
    function(hname: any, hvalue: any): any {
                          hname = hname.join('').toLowerCase();
                          hvalue = hvalue.join('');
                          options = options || { data: {}};
                          if(!options.data.uri_headers) options.data.uri_headers = {};
                          if (!options.data.uri_headers[hname]) {
                            options.data.uri_headers[hname] = [hvalue];
                          } else {
                            options.data.uri_headers[hname].push(hvalue);
                          }},
    function(): any {
                          options = options || { data: {}};
                          // lots of tests fail if this isn't guarded...
                          if (options.startRule === 'Refer_To') {
                            options.data.uri = new URI(options.data.scheme, options.data.user, options.data.host, options.data.port, options.data.uri_params, options.data.uri_headers);
                            delete options.data.scheme;
                            delete options.data.user;
                            delete options.data.host;
                            delete options.data.host_type;
                            delete options.data.port;
                            delete options.data.uri_params;
                          }
                        },
    "//",
    peg$literalExpectation("//", false),
    function(): any {
                        options = options || { data: {}};
                        options.data.scheme= text(); },
    peg$literalExpectation("SIP", true),
    function(): any {
                        options = options || { data: {}};
                        options.data.sip_version = text(); },
    "INVITE",
    peg$literalExpectation("INVITE", false),
    "ACK",
    peg$literalExpectation("ACK", false),
    "VXACH",
    peg$literalExpectation("VXACH", false),
    "OPTIONS",
    peg$literalExpectation("OPTIONS", false),
    "BYE",
    peg$literalExpectation("BYE", false),
    "CANCEL",
    peg$literalExpectation("CANCEL", false),
    "REGISTER",
    peg$literalExpectation("REGISTER", false),
    "SUBSCRIBE",
    peg$literalExpectation("SUBSCRIBE", false),
    "NOTIFY",
    peg$literalExpectation("NOTIFY", false),
    "REFER",
    peg$literalExpectation("REFER", false),
    "PUBLISH",
    peg$literalExpectation("PUBLISH", false),
    function(): any {

                        options = options || { data: {}};
                        options.data.method = text();
                        return options.data.method; },
    function(status_code: any): any {
                      options = options || { data: {}};
                      options.data.status_code = parseInt(status_code.join('')); },
    function(): any {
                      options = options || { data: {}};
                      options.data.reason_phrase = text(); },
    function(): any {
                  options = options || { data: {}};
                  options.data = text(); },
    function(): any {
                            var idx, length;
                            options = options || { data: {}};
                            length = options.data.multi_header.length;
                            for (idx = 0; idx < length; idx++) {
                              if (options.data.multi_header[idx].parsed === null) {
                                options.data = null;
                                break;
                              }
                            }
                            if (options.data !== null) {
                              options.data = options.data.multi_header;
                            } else {
                              options.data = -1;
                            }},
    function(): any {
                            var header;
                            options = options || { data: {}};
                            if(!options.data.multi_header) options.data.multi_header = [];
                            try {
                              header = new NameAddrHeader(options.data.uri, options.data.displayName, options.data.params);
                              delete options.data.uri;
                              delete options.data.displayName;
                              delete options.data.params;
                            } catch(e) {
                              header = null;
                            }
                            options.data.multi_header.push( { 'position': peg$currPos,
                                                      'offset': location().start.offset,
                                                      'parsed': header
                                                    });},
    function(displayName: any): any {
                            displayName = text().trim();
                            if (displayName[0] === '\"') {
                              displayName = displayName.substring(1, displayName.length-1);
                            }
                            options = options || { data: {}};
                            options.data.displayName = displayName; },
    "q",
    peg$literalExpectation("q", true),
    function(q: any): any {
                            options = options || { data: {}};
                            if(!options.data.params) options.data.params = {};
                            options.data.params['q'] = q; },
    "expires",
    peg$literalExpectation("expires", true),
    function(expires: any): any {
                            options = options || { data: {}};
                            if(!options.data.params) options.data.params = {};
                            options.data.params['expires'] = expires; },
    function(delta_seconds: any): any {
                            return parseInt(delta_seconds.join('')); },
    "0",
    peg$literalExpectation("0", false),
    function(): any {
                            return parseFloat(text()); },
    function(param: any, value: any): any {
                            options = options || { data: {}};
                            if(!options.data.params) options.data.params = {};
                            if (value === null){
                              value = undefined;
                            }
                            else {
                              value = value[1];
                            }
                            options.data.params[param.toLowerCase()] = value;},
    "render",
    peg$literalExpectation("render", true),
    "session",
    peg$literalExpectation("session", true),
    "icon",
    peg$literalExpectation("icon", true),
    "alert",
    peg$literalExpectation("alert", true),
    function(): any {
                                options = options || { data: {}};
                                if (options.startRule === 'Content_Disposition') {
                                  options.data.type = text().toLowerCase();
                                }
                              },
    "handling",
    peg$literalExpectation("handling", true),
    "optional",
    peg$literalExpectation("optional", true),
    "required",
    peg$literalExpectation("required", true),
    function(length: any): any {
                            options = options || { data: {}};
                            options.data = parseInt(length.join('')); },
    function(): any {
                            options = options || { data: {}};
                            options.data = text(); },
    "text",
    peg$literalExpectation("text", true),
    "image",
    peg$literalExpectation("image", true),
    "audio",
    peg$literalExpectation("audio", true),
    "video",
    peg$literalExpectation("video", true),
    "application",
    peg$literalExpectation("application", true),
    "message",
    peg$literalExpectation("message", true),
    "multipart",
    peg$literalExpectation("multipart", true),
    "x-",
    peg$literalExpectation("x-", true),
    function(cseq_value: any): any {
                      options = options || { data: {}};
                      options.data.value=parseInt(cseq_value.join('')); },
    function(expires: any): any {options = options || { data: {}}; options.data = expires; },
    function(event_type: any): any {
                           options = options || { data: {}};
                           options.data.event = event_type.toLowerCase(); },
    function(): any {
                    options = options || { data: {}};
                    var tag = options.data.tag;
                      options.data = new NameAddrHeader(options.data.uri, options.data.displayName, options.data.params);
                      if (tag) {options.data.setParam('tag',tag)}
                    },
    "tag",
    peg$literalExpectation("tag", true),
    function(tag: any): any {options = options || { data: {}};options.data.tag = tag; },
    function(forwards: any): any {
                      options = options || { data: {}};
                      options.data = parseInt(forwards.join('')); },
    function(min_expires: any): any {options = options || { data: {}}; options.data = min_expires; },
    function(): any {
                            options = options || { data: {}};
                            options.data = new NameAddrHeader(options.data.uri, options.data.displayName, options.data.params);
                          },
    "digest",
    peg$literalExpectation("Digest", true),
    "realm",
    peg$literalExpectation("realm", true),
    function(realm: any): any { options = options || { data: {}}; options.data.realm = realm; },
    "domain",
    peg$literalExpectation("domain", true),
    "nonce",
    peg$literalExpectation("nonce", true),
    function(nonce: any): any { options = options || { data: {}}; options.data.nonce=nonce; },
    "opaque",
    peg$literalExpectation("opaque", true),
    function(opaque: any): any { options = options || { data: {}}; options.data.opaque=opaque; },
    "stale",
    peg$literalExpectation("stale", true),
    "true",
    peg$literalExpectation("true", true),
    function(): any { options = options || { data: {}}; options.data.stale=true; },
    "false",
    peg$literalExpectation("false", true),
    function(): any { options = options || { data: {}}; options.data.stale=false; },
    "algorithm",
    peg$literalExpectation("algorithm", true),
    "md5",
    peg$literalExpectation("MD5", true),
    "md5-sess",
    peg$literalExpectation("MD5-sess", true),
    function(algorithm: any): any {
                          options = options || { data: {}};
                          options.data.algorithm=algorithm.toUpperCase(); },
    "qop",
    peg$literalExpectation("qop", true),
    "auth-int",
    peg$literalExpectation("auth-int", true),
    "auth",
    peg$literalExpectation("auth", true),
    function(qop_value: any): any {
                            options = options || { data: {}};
                            options.data.qop || (options.data.qop=[]);
                            options.data.qop.push(qop_value.toLowerCase()); },
    function(rack_value: any): any {
                      options = options || { data: {}};
                      options.data.value=parseInt(rack_value.join('')); },
    function(): any {
                      var idx, length;
                      options = options || { data: {}};
                      length = options.data.multi_header.length;
                      for (idx = 0; idx < length; idx++) {
                        if (options.data.multi_header[idx].parsed === null) {
                          options.data = null;
                          break;
                        }
                      }
                      if (options.data !== null) {
                        options.data = options.data.multi_header;
                      } else {
                        options.data = -1;
                      }},
    function(): any {
                      var header;
                      options = options || { data: {}};
                      if(!options.data.multi_header) options.data.multi_header = [];
                      try {
                        header = new NameAddrHeader(options.data.uri, options.data.displayName, options.data.params);
                        delete options.data.uri;
                        delete options.data.displayName;
                        delete options.data.params;
                      } catch(e) {
                        header = null;
                      }
                      options.data.multi_header.push( { 'position': peg$currPos,
                                                'offset': location().start.offset,
                                                'parsed': header
                                              });},
    function(): any {
                  options = options || { data: {}};
                  options.data = new NameAddrHeader(options.data.uri, options.data.displayName, options.data.params);
                },
    function(): any {
                          options = options || { data: {}};
                          if (!(options.data.replaces_from_tag && options.data.replaces_to_tag)) {
                            options.data = -1;
                          }
                        },
    function(): any {
                          options = options || { data: {}};
                          options.data = {
                            call_id: options.data
                          };
                        },
    "from-tag",
    peg$literalExpectation("from-tag", true),
    function(from_tag: any): any {
                          options = options || { data: {}};
                          options.data.replaces_from_tag = from_tag;
                        },
    "to-tag",
    peg$literalExpectation("to-tag", true),
    function(to_tag: any): any {
                          options = options || { data: {}};
                          options.data.replaces_to_tag = to_tag;
                        },
    "early-only",
    peg$literalExpectation("early-only", true),
    function(): any {
                          options = options || { data: {}};
                          options.data.early_only = true;
                        },
    function(head: any, r: any): any {return r;},
    function(head: any, tail: any): any { return list(head, tail); },
    function(value: any): any {
                    options = options || { data: {}};
                    if (options.startRule === 'Require') {
                      options.data = value || [];
                    }
                  },
    function(rseq_value: any): any {
                      options = options || { data: {}};
                      options.data.value=parseInt(rseq_value.join('')); },
    "active",
    peg$literalExpectation("active", true),
    "pending",
    peg$literalExpectation("pending", true),
    "terminated",
    peg$literalExpectation("terminated", true),
    function(): any {
                            options = options || { data: {}};
                            options.data.state = text(); },
    "reason",
    peg$literalExpectation("reason", true),
    function(reason: any): any {
                            options = options || { data: {}};
                            if (typeof reason !== 'undefined') options.data.reason = reason; },
    function(expires: any): any {
                            options = options || { data: {}};
                            if (typeof expires !== 'undefined') options.data.expires = expires; },
    "retry_after",
    peg$literalExpectation("retry_after", true),
    function(retry_after: any): any {
                            options = options || { data: {}};
                            if (typeof retry_after !== 'undefined') options.data.retry_after = retry_after; },
    "deactivated",
    peg$literalExpectation("deactivated", true),
    "probation",
    peg$literalExpectation("probation", true),
    "rejected",
    peg$literalExpectation("rejected", true),
    "timeout",
    peg$literalExpectation("timeout", true),
    "giveup",
    peg$literalExpectation("giveup", true),
    "noresource",
    peg$literalExpectation("noresource", true),
    "invariant",
    peg$literalExpectation("invariant", true),
    function(value: any): any {
                    options = options || { data: {}};
                    if (options.startRule === 'Supported') {
                      options.data = value || [];
                    }
                  },
    function(): any {
                  options = options || { data: {}};
                  var tag = options.data.tag;
                    options.data = new NameAddrHeader(options.data.uri, options.data.displayName, options.data.params);
                    if (tag) {options.data.setParam('tag',tag)}
                  },
    "ttl",
    peg$literalExpectation("ttl", true),
    function(via_ttl_value: any): any {
                          options = options || { data: {}};
                          options.data.ttl = via_ttl_value; },
    "maddr",
    peg$literalExpectation("maddr", true),
    function(via_maddr: any): any {
                          options = options || { data: {}};
                          options.data.maddr = via_maddr; },
    "received",
    peg$literalExpectation("received", true),
    function(via_received: any): any {
                          options = options || { data: {}};
                          options.data.received = via_received; },
    "branch",
    peg$literalExpectation("branch", true),
    function(via_branch: any): any {
                          options = options || { data: {}};
                          options.data.branch = via_branch; },
    "rport",
    peg$literalExpectation("rport", true),
    function(response_port: any): any {
                          options = options || { data: {}};
                          if(typeof response_port !== 'undefined')
                            options.data.rport = response_port.join(''); },
    function(via_protocol: any): any {
                          options = options || { data: {}};
                          options.data.protocol = via_protocol; },
    peg$literalExpectation("UDP", true),
    peg$literalExpectation("TCP", true),
    peg$literalExpectation("TLS", true),
    peg$literalExpectation("SCTP", true),
    function(via_transport: any): any {
                          options = options || { data: {}};
                          options.data.transport = via_transport; },
    function(): any {
                          options = options || { data: {}};
                          options.data.host = text(); },
    function(via_sent_by_port: any): any {
                          options = options || { data: {}};
                          options.data.port = parseInt(via_sent_by_port.join('')); },
    function(ttl: any): any {
                          return parseInt(ttl.join('')); },
    function(deltaSeconds: any): any {
                          options = options || { data: {}};
                          if (options.startRule === 'Session_Expires') {
                            options.data.deltaSeconds = deltaSeconds;
                          }
                        },
    "refresher",
    peg$literalExpectation("refresher", false),
    "uas",
    peg$literalExpectation("uas", false),
    "uac",
    peg$literalExpectation("uac", false),
    function(endpoint: any): any {
                          options = options || { data: {}};
                          if (options.startRule === 'Session_Expires') {
                            options.data.refresher = endpoint;
                          }
                        },
    function(deltaSeconds: any): any {
                          options = options || { data: {}};
                          if (options.startRule === 'Min_SE') {
                            options.data = deltaSeconds;
                          }
                        },
    "stuns",
    peg$literalExpectation("stuns", true),
    "stun",
    peg$literalExpectation("stun", true),
    function(scheme: any): any {
                          options = options || { data: {}};options.data.scheme = scheme; },
    function(host: any): any {
                          options = options || { data: {}};
                          options.data.host = host; },
    "?transport=",
    peg$literalExpectation("?transport=", false),
    "turns",
    peg$literalExpectation("turns", true),
    "turn",
    peg$literalExpectation("turn", true),
    function(transport: any): any {
                          options = options || { data: {}};options.data.transport = transport; },
    function(): any {
                      options = options || { data: {}};options.data = text(); },
    "Referred-By",
    peg$literalExpectation("Referred-By", false),
    "b",
    peg$literalExpectation("b", false),
    "cid",
    peg$literalExpectation("cid", false)
  ];

  const peg$bytecode = [
    peg$decode("2 \"\"6 7!"),
    peg$decode("4\"\"\"5!7#"),
    peg$decode("4$\"\"5!7%"),
    peg$decode("4&\"\"5!7'"),
    peg$decode(";'.# &;("),
    peg$decode("4(\"\"5!7)"),
    peg$decode("4*\"\"5!7+"),
    peg$decode("2,\"\"6,7-"),
    peg$decode("2.\"\"6.7/"),
    peg$decode("40\"\"5!71"),
    peg$decode("22\"\"6273.\x89 &24\"\"6475.} &26\"\"6677.q &28\"\"6879.e &2:\"\"6:7;.Y &2<\"\"6<7=.M &2>\"\"6>7?.A &2@\"\"6@7A.5 &2B\"\"6B7C.) &2D\"\"6D7E"),
    peg$decode(";).# &;,"),
    peg$decode("2F\"\"6F7G.} &2H\"\"6H7I.q &2J\"\"6J7K.e &2L\"\"6L7M.Y &2N\"\"6N7O.M &2P\"\"6P7Q.A &2R\"\"6R7S.5 &2T\"\"6T7U.) &2V\"\"6V7W"),
    peg$decode("%%2X\"\"6X7Y/5#;#/,$;#/#$+#)(#'#(\"'#&'#/\"!&,)"),
    peg$decode("%%$;$0#*;$&/,#; /#$+\")(\"'#&'#.\" &\"/=#$;$/&#0#*;$&&&#/'$8\":Z\" )(\"'#&'#"),
    peg$decode(";..\" &\""),
    peg$decode("%$;'.# &;(0)*;'.# &;(&/?#28\"\"6879/0$;//'$8#:[# )(#'#(\"'#&'#"),
    peg$decode("%%$;2/&#0#*;2&&&#/g#$%$;.0#*;.&/,#;2/#$+\")(\"'#&'#0=*%$;.0#*;.&/,#;2/#$+\")(\"'#&'#&/#$+\")(\"'#&'#/\"!&,)"),
    peg$decode("4\\\"\"5!7].# &;3"),
    peg$decode("4^\"\"5!7_"),
    peg$decode("4`\"\"5!7a"),
    peg$decode(";!.) &4b\"\"5!7c"),
    peg$decode("%$;).\x95 &2F\"\"6F7G.\x89 &2J\"\"6J7K.} &2L\"\"6L7M.q &2X\"\"6X7Y.e &2P\"\"6P7Q.Y &2H\"\"6H7I.M &2@\"\"6@7A.A &2d\"\"6d7e.5 &2R\"\"6R7S.) &2N\"\"6N7O/\x9E#0\x9B*;).\x95 &2F\"\"6F7G.\x89 &2J\"\"6J7K.} &2L\"\"6L7M.q &2X\"\"6X7Y.e &2P\"\"6P7Q.Y &2H\"\"6H7I.M &2@\"\"6@7A.A &2d\"\"6d7e.5 &2R\"\"6R7S.) &2N\"\"6N7O&&&#/\"!&,)"),
    peg$decode("%$;).\x89 &2F\"\"6F7G.} &2L\"\"6L7M.q &2X\"\"6X7Y.e &2P\"\"6P7Q.Y &2H\"\"6H7I.M &2@\"\"6@7A.A &2d\"\"6d7e.5 &2R\"\"6R7S.) &2N\"\"6N7O/\x92#0\x8F*;).\x89 &2F\"\"6F7G.} &2L\"\"6L7M.q &2X\"\"6X7Y.e &2P\"\"6P7Q.Y &2H\"\"6H7I.M &2@\"\"6@7A.A &2d\"\"6d7e.5 &2R\"\"6R7S.) &2N\"\"6N7O&&&#/\"!&,)"),
    peg$decode("2T\"\"6T7U.\xE3 &2V\"\"6V7W.\xD7 &2f\"\"6f7g.\xCB &2h\"\"6h7i.\xBF &2:\"\"6:7;.\xB3 &2D\"\"6D7E.\xA7 &22\"\"6273.\x9B &28\"\"6879.\x8F &2j\"\"6j7k.\x83 &;&.} &24\"\"6475.q &2l\"\"6l7m.e &2n\"\"6n7o.Y &26\"\"6677.M &2>\"\"6>7?.A &2p\"\"6p7q.5 &2r\"\"6r7s.) &;'.# &;("),
    peg$decode("%$;).\u012B &2F\"\"6F7G.\u011F &2J\"\"6J7K.\u0113 &2L\"\"6L7M.\u0107 &2X\"\"6X7Y.\xFB &2P\"\"6P7Q.\xEF &2H\"\"6H7I.\xE3 &2@\"\"6@7A.\xD7 &2d\"\"6d7e.\xCB &2R\"\"6R7S.\xBF &2N\"\"6N7O.\xB3 &2T\"\"6T7U.\xA7 &2V\"\"6V7W.\x9B &2f\"\"6f7g.\x8F &2h\"\"6h7i.\x83 &28\"\"6879.w &2j\"\"6j7k.k &;&.e &24\"\"6475.Y &2l\"\"6l7m.M &2n\"\"6n7o.A &26\"\"6677.5 &2p\"\"6p7q.) &2r\"\"6r7s/\u0134#0\u0131*;).\u012B &2F\"\"6F7G.\u011F &2J\"\"6J7K.\u0113 &2L\"\"6L7M.\u0107 &2X\"\"6X7Y.\xFB &2P\"\"6P7Q.\xEF &2H\"\"6H7I.\xE3 &2@\"\"6@7A.\xD7 &2d\"\"6d7e.\xCB &2R\"\"6R7S.\xBF &2N\"\"6N7O.\xB3 &2T\"\"6T7U.\xA7 &2V\"\"6V7W.\x9B &2f\"\"6f7g.\x8F &2h\"\"6h7i.\x83 &28\"\"6879.w &2j\"\"6j7k.k &;&.e &24\"\"6475.Y &2l\"\"6l7m.M &2n\"\"6n7o.A &26\"\"6677.5 &2p\"\"6p7q.) &2r\"\"6r7s&&&#/\"!&,)"),
    peg$decode("%;//?#2P\"\"6P7Q/0$;//'$8#:t# )(#'#(\"'#&'#"),
    peg$decode("%;//?#24\"\"6475/0$;//'$8#:u# )(#'#(\"'#&'#"),
    peg$decode("%;//?#2>\"\"6>7?/0$;//'$8#:v# )(#'#(\"'#&'#"),
    peg$decode("%;//?#2T\"\"6T7U/0$;//'$8#:w# )(#'#(\"'#&'#"),
    peg$decode("%;//?#2V\"\"6V7W/0$;//'$8#:x# )(#'#(\"'#&'#"),
    peg$decode("%2h\"\"6h7i/0#;//'$8\":y\" )(\"'#&'#"),
    peg$decode("%;//6#2f\"\"6f7g/'$8\":z\" )(\"'#&'#"),
    peg$decode("%;//?#2D\"\"6D7E/0$;//'$8#:{# )(#'#(\"'#&'#"),
    peg$decode("%;//?#22\"\"6273/0$;//'$8#:|# )(#'#(\"'#&'#"),
    peg$decode("%;//?#28\"\"6879/0$;//'$8#:}# )(#'#(\"'#&'#"),
    peg$decode("%;//0#;&/'$8\":~\" )(\"'#&'#"),
    peg$decode("%;&/0#;//'$8\":~\" )(\"'#&'#"),
    peg$decode("%;=/T#$;G.) &;K.# &;F0/*;G.) &;K.# &;F&/,$;>/#$+#)(#'#(\"'#&'#"),
    peg$decode("4\x7F\"\"5!7\x80.A &4\x81\"\"5!7\x82.5 &4\x83\"\"5!7\x84.) &;3.# &;."),
    peg$decode("%%;//Q#;&/H$$;J.# &;K0)*;J.# &;K&/,$;&/#$+$)($'#(#'#(\"'#&'#/\"!&,)"),
    peg$decode("%;//]#;&/T$%$;J.# &;K0)*;J.# &;K&/\"!&,)/1$;&/($8$:\x85$!!)($'#(#'#(\"'#&'#"),
    peg$decode(";..G &2L\"\"6L7M.; &4\x86\"\"5!7\x87./ &4\x83\"\"5!7\x84.# &;3"),
    peg$decode("%2j\"\"6j7k/J#4\x88\"\"5!7\x89.5 &4\x8A\"\"5!7\x8B.) &4\x8C\"\"5!7\x8D/#$+\")(\"'#&'#"),
    peg$decode("%;N/M#28\"\"6879/>$;O.\" &\"/0$;S/'$8$:\x8E$ )($'#(#'#(\"'#&'#"),
    peg$decode("%;N/d#28\"\"6879/U$;O.\" &\"/G$;S/>$;_/5$;l.\" &\"/'$8&:\x8F& )(&'#(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%3\x90\"\"5$7\x91.) &3\x92\"\"5#7\x93/' 8!:\x94!! )"),
    peg$decode("%;P/]#%28\"\"6879/,#;R/#$+\")(\"'#&'#.\" &\"/6$2:\"\"6:7;/'$8#:\x95# )(#'#(\"'#&'#"),
    peg$decode("$;+.) &;-.# &;Q/2#0/*;+.) &;-.# &;Q&&&#"),
    peg$decode("2<\"\"6<7=.q &2>\"\"6>7?.e &2@\"\"6@7A.Y &2B\"\"6B7C.M &2D\"\"6D7E.A &22\"\"6273.5 &26\"\"6677.) &24\"\"6475"),
    peg$decode("%$;+._ &;-.Y &2<\"\"6<7=.M &2>\"\"6>7?.A &2@\"\"6@7A.5 &2B\"\"6B7C.) &2D\"\"6D7E0e*;+._ &;-.Y &2<\"\"6<7=.M &2>\"\"6>7?.A &2@\"\"6@7A.5 &2B\"\"6B7C.) &2D\"\"6D7E&/& 8!:\x96! )"),
    peg$decode("%;T/J#%28\"\"6879/,#;^/#$+\")(\"'#&'#.\" &\"/#$+\")(\"'#&'#"),
    peg$decode("%;U.) &;\\.# &;X/& 8!:\x97! )"),
    peg$decode("%$%;V/2#2J\"\"6J7K/#$+\")(\"'#&'#0<*%;V/2#2J\"\"6J7K/#$+\")(\"'#&'#&/D#;W/;$2J\"\"6J7K.\" &\"/'$8#:\x98# )(#'#(\"'#&'#"),
    peg$decode("$4\x99\"\"5!7\x9A/,#0)*4\x99\"\"5!7\x9A&&&#"),
    peg$decode("%40\"\"5!71/?#$4\x9B\"\"5!7\x9C0)*4\x9B\"\"5!7\x9C&/#$+\")(\"'#&'#"),
    peg$decode("%2l\"\"6l7m/?#;Y/6$2n\"\"6n7o/'$8#:\x9D# )(#'#(\"'#&'#"),
    peg$decode("%%;Z/\xB3#28\"\"6879/\xA4$;Z/\x9B$28\"\"6879/\x8C$;Z/\x83$28\"\"6879/t$;Z/k$28\"\"6879/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+-)(-'#(,'#(+'#(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u0790 &%2\x9E\"\"6\x9E7\x9F/\xA4#;Z/\x9B$28\"\"6879/\x8C$;Z/\x83$28\"\"6879/t$;Z/k$28\"\"6879/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+,)(,'#(+'#(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u06F9 &%2\x9E\"\"6\x9E7\x9F/\x8C#;Z/\x83$28\"\"6879/t$;Z/k$28\"\"6879/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+*)(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u067A &%2\x9E\"\"6\x9E7\x9F/t#;Z/k$28\"\"6879/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+()(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u0613 &%2\x9E\"\"6\x9E7\x9F/\\#;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+&)(&'#(%'#($'#(#'#(\"'#&'#.\u05C4 &%2\x9E\"\"6\x9E7\x9F/D#;Z/;$28\"\"6879/,$;[/#$+$)($'#(#'#(\"'#&'#.\u058D &%2\x9E\"\"6\x9E7\x9F/,#;[/#$+\")(\"'#&'#.\u056E &%2\x9E\"\"6\x9E7\x9F/,#;Z/#$+\")(\"'#&'#.\u054F &%;Z/\x9B#2\x9E\"\"6\x9E7\x9F/\x8C$;Z/\x83$28\"\"6879/t$;Z/k$28\"\"6879/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$++)(+'#(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u04C7 &%;Z/\xAA#%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\x83$2\x9E\"\"6\x9E7\x9F/t$;Z/k$28\"\"6879/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+*)(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u0430 &%;Z/\xB9#%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\x92$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/k$2\x9E\"\"6\x9E7\x9F/\\$;Z/S$28\"\"6879/D$;Z/;$28\"\"6879/,$;[/#$+))()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u038A &%;Z/\xC8#%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xA1$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/z$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/S$2\x9E\"\"6\x9E7\x9F/D$;Z/;$28\"\"6879/,$;[/#$+()(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u02D5 &%;Z/\xD7#%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xB0$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\x89$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/b$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/;$2\x9E\"\"6\x9E7\x9F/,$;[/#$+')(''#(&'#(%'#($'#(#'#(\"'#&'#.\u0211 &%;Z/\xFE#%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xD7$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xB0$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\x89$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/b$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/;$2\x9E\"\"6\x9E7\x9F/,$;Z/#$+()(('#(''#(&'#(%'#($'#(#'#(\"'#&'#.\u0126 &%;Z/\u011C#%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xF5$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xCE$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\xA7$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/\x80$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/Y$%28\"\"6879/,#;Z/#$+\")(\"'#&'#.\" &\"/2$2\x9E\"\"6\x9E7\x9F/#$+()(('#(''#(&'#(%'#($'#(#'#(\"'#&'#/& 8!:\xA0! )"),
    peg$decode("%;#/M#;#.\" &\"/?$;#.\" &\"/1$;#.\" &\"/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode("%;Z/;#28\"\"6879/,$;Z/#$+#)(#'#(\"'#&'#.# &;\\"),
    peg$decode("%;]/o#2J\"\"6J7K/`$;]/W$2J\"\"6J7K/H$;]/?$2J\"\"6J7K/0$;]/'$8':\xA1' )(''#(&'#(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%2\xA2\"\"6\xA27\xA3/2#4\xA4\"\"5!7\xA5/#$+\")(\"'#&'#.\x98 &%2\xA6\"\"6\xA67\xA7/;#4\xA8\"\"5!7\xA9/,$;!/#$+#)(#'#(\"'#&'#.j &%2\xAA\"\"6\xAA7\xAB/5#;!/,$;!/#$+#)(#'#(\"'#&'#.B &%4\xAC\"\"5!7\xAD/,#;!/#$+\")(\"'#&'#.# &;!"),
    peg$decode("%%;!.\" &\"/[#;!.\" &\"/M$;!.\" &\"/?$;!.\" &\"/1$;!.\" &\"/#$+%)(%'#($'#(#'#(\"'#&'#/' 8!:\xAE!! )"),
    peg$decode("$%22\"\"6273/,#;`/#$+\")(\"'#&'#0<*%22\"\"6273/,#;`/#$+\")(\"'#&'#&"),
    peg$decode(";a.A &;b.; &;c.5 &;d./ &;e.) &;f.# &;g"),
    peg$decode("%3\xAF\"\"5*7\xB0/a#3\xB1\"\"5#7\xB2.G &3\xB3\"\"5#7\xB4.; &3\xB5\"\"5$7\xB6./ &3\xB7\"\"5#7\xB8.# &;6/($8\":\xB9\"! )(\"'#&'#"),
    peg$decode("%3\xBA\"\"5%7\xBB/I#3\xBC\"\"5%7\xBD./ &3\xBE\"\"5\"7\xBF.# &;6/($8\":\xC0\"! )(\"'#&'#"),
    peg$decode("%3\xC1\"\"5'7\xC2/1#;\x90/($8\":\xC3\"! )(\"'#&'#"),
    peg$decode("%3\xC4\"\"5$7\xC5/1#;\xF0/($8\":\xC6\"! )(\"'#&'#"),
    peg$decode("%3\xC7\"\"5&7\xC8/1#;T/($8\":\xC9\"! )(\"'#&'#"),
    peg$decode("%3\xCA\"\"5\"7\xCB/N#%2>\"\"6>7?/,#;6/#$+\")(\"'#&'#.\" &\"/'$8\":\xCC\" )(\"'#&'#"),
    peg$decode("%;h/P#%2>\"\"6>7?/,#;i/#$+\")(\"'#&'#.\" &\"/)$8\":\xCD\"\"! )(\"'#&'#"),
    peg$decode("%$;j/&#0#*;j&&&#/\"!&,)"),
    peg$decode("%$;j/&#0#*;j&&&#/\"!&,)"),
    peg$decode(";k.) &;+.# &;-"),
    peg$decode("2l\"\"6l7m.e &2n\"\"6n7o.Y &24\"\"6475.M &28\"\"6879.A &2<\"\"6<7=.5 &2@\"\"6@7A.) &2B\"\"6B7C"),
    peg$decode("%26\"\"6677/n#;m/e$$%2<\"\"6<7=/,#;m/#$+\")(\"'#&'#0<*%2<\"\"6<7=/,#;m/#$+\")(\"'#&'#&/#$+#)(#'#(\"'#&'#"),
    peg$decode("%;n/A#2>\"\"6>7?/2$;o/)$8#:\xCE#\"\" )(#'#(\"'#&'#"),
    peg$decode("$;p.) &;+.# &;-/2#0/*;p.) &;+.# &;-&&&#"),
    peg$decode("$;p.) &;+.# &;-0/*;p.) &;+.# &;-&"),
    peg$decode("2l\"\"6l7m.e &2n\"\"6n7o.Y &24\"\"6475.M &26\"\"6677.A &28\"\"6879.5 &2@\"\"6@7A.) &2B\"\"6B7C"),
    peg$decode(";\x91.# &;r"),
    peg$decode("%;\x90/G#;'/>$;s/5$;'/,$;\x84/#$+%)(%'#($'#(#'#(\"'#&'#"),
    peg$decode(";M.# &;t"),
    peg$decode("%;\x7F/E#28\"\"6879/6$;u.# &;x/'$8#:\xCF# )(#'#(\"'#&'#"),
    peg$decode("%;v.# &;w/J#%26\"\"6677/,#;\x83/#$+\")(\"'#&'#.\" &\"/#$+\")(\"'#&'#"),
    peg$decode("%2\xD0\"\"6\xD07\xD1/:#;\x80/1$;w.\" &\"/#$+#)(#'#(\"'#&'#"),
    peg$decode("%24\"\"6475/,#;{/#$+\")(\"'#&'#"),
    peg$decode("%;z/3#$;y0#*;y&/#$+\")(\"'#&'#"),
    peg$decode(";*.) &;+.# &;-"),
    peg$decode(";+.\x8F &;-.\x89 &22\"\"6273.} &26\"\"6677.q &28\"\"6879.e &2:\"\"6:7;.Y &2<\"\"6<7=.M &2>\"\"6>7?.A &2@\"\"6@7A.5 &2B\"\"6B7C.) &2D\"\"6D7E"),
    peg$decode("%;|/e#$%24\"\"6475/,#;|/#$+\")(\"'#&'#0<*%24\"\"6475/,#;|/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%$;~0#*;~&/e#$%22\"\"6273/,#;}/#$+\")(\"'#&'#0<*%22\"\"6273/,#;}/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("$;~0#*;~&"),
    peg$decode(";+.w &;-.q &28\"\"6879.e &2:\"\"6:7;.Y &2<\"\"6<7=.M &2>\"\"6>7?.A &2@\"\"6@7A.5 &2B\"\"6B7C.) &2D\"\"6D7E"),
    peg$decode("%%;\"/\x87#$;\".G &;!.A &2@\"\"6@7A.5 &2F\"\"6F7G.) &2J\"\"6J7K0M*;\".G &;!.A &2@\"\"6@7A.5 &2F\"\"6F7G.) &2J\"\"6J7K&/#$+\")(\"'#&'#/& 8!:\xD2! )"),
    peg$decode(";\x81.# &;\x82"),
    peg$decode("%%;O/2#2:\"\"6:7;/#$+\")(\"'#&'#.\" &\"/,#;S/#$+\")(\"'#&'#.\" &\""),
    peg$decode("$;+.\x83 &;-.} &2B\"\"6B7C.q &2D\"\"6D7E.e &22\"\"6273.Y &28\"\"6879.M &2:\"\"6:7;.A &2<\"\"6<7=.5 &2>\"\"6>7?.) &2@\"\"6@7A/\x8C#0\x89*;+.\x83 &;-.} &2B\"\"6B7C.q &2D\"\"6D7E.e &22\"\"6273.Y &28\"\"6879.M &2:\"\"6:7;.A &2<\"\"6<7=.5 &2>\"\"6>7?.) &2@\"\"6@7A&&&#"),
    peg$decode("$;y0#*;y&"),
    peg$decode("%3\x92\"\"5#7\xD3/q#24\"\"6475/b$$;!/&#0#*;!&&&#/L$2J\"\"6J7K/=$$;!/&#0#*;!&&&#/'$8%:\xD4% )(%'#($'#(#'#(\"'#&'#"),
    peg$decode("2\xD5\"\"6\xD57\xD6"),
    peg$decode("2\xD7\"\"6\xD77\xD8"),
    peg$decode("2\xD9\"\"6\xD97\xDA"),
    peg$decode("2\xDB\"\"6\xDB7\xDC"),
    peg$decode("2\xDD\"\"6\xDD7\xDE"),
    peg$decode("2\xDF\"\"6\xDF7\xE0"),
    peg$decode("2\xE1\"\"6\xE17\xE2"),
    peg$decode("2\xE3\"\"6\xE37\xE4"),
    peg$decode("2\xE5\"\"6\xE57\xE6"),
    peg$decode("2\xE7\"\"6\xE77\xE8"),
    peg$decode("2\xE9\"\"6\xE97\xEA"),
    peg$decode("%;\x85.Y &;\x86.S &;\x88.M &;\x89.G &;\x8A.A &;\x8B.; &;\x8C.5 &;\x8F./ &;\x8D.) &;\x8E.# &;6/& 8!:\xEB! )"),
    peg$decode("%;\x84/G#;'/>$;\x92/5$;'/,$;\x94/#$+%)(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%;\x93/' 8!:\xEC!! )"),
    peg$decode("%;!/5#;!/,$;!/#$+#)(#'#(\"'#&'#"),
    peg$decode("%$;*.A &;+.; &;-.5 &;3./ &;4.) &;'.# &;(0G*;*.A &;+.; &;-.5 &;3./ &;4.) &;'.# &;(&/& 8!:\xED! )"),
    peg$decode("%;\xB6/Y#$%;A/,#;\xB6/#$+\")(\"'#&'#06*%;A/,#;\xB6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%;9/N#%2:\"\"6:7;/,#;9/#$+\")(\"'#&'#.\" &\"/'$8\":\xEE\" )(\"'#&'#"),
    peg$decode("%;:.c &%;\x98/Y#$%;A/,#;\x98/#$+\")(\"'#&'#06*%;A/,#;\x98/#$+\")(\"'#&'#&/#$+\")(\"'#&'#/& 8!:\xEF! )"),
    peg$decode("%;L.# &;\x99/]#$%;B/,#;\x9B/#$+\")(\"'#&'#06*%;B/,#;\x9B/#$+\")(\"'#&'#&/'$8\":\xF0\" )(\"'#&'#"),
    peg$decode("%;\x9A.\" &\"/>#;@/5$;M/,$;?/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode("%%;6/Y#$%;./,#;6/#$+\")(\"'#&'#06*%;./,#;6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#.# &;H/' 8!:\xF1!! )"),
    peg$decode(";\x9C.) &;\x9D.# &;\xA0"),
    peg$decode("%3\xF2\"\"5!7\xF3/:#;</1$;\x9F/($8#:\xF4#! )(#'#(\"'#&'#"),
    peg$decode("%3\xF5\"\"5'7\xF6/:#;</1$;\x9E/($8#:\xF7#! )(#'#(\"'#&'#"),
    peg$decode("%$;!/&#0#*;!&&&#/' 8!:\xF8!! )"),
    peg$decode("%2\xF9\"\"6\xF97\xFA/o#%2J\"\"6J7K/M#;!.\" &\"/?$;!.\" &\"/1$;!.\" &\"/#$+$)($'#(#'#(\"'#&'#.\" &\"/'$8\":\xFB\" )(\"'#&'#"),
    peg$decode("%;6/J#%;</,#;\xA1/#$+\")(\"'#&'#.\" &\"/)$8\":\xFC\"\"! )(\"'#&'#"),
    peg$decode(";6.) &;T.# &;H"),
    peg$decode("%;\xA3/Y#$%;B/,#;\xA4/#$+\")(\"'#&'#06*%;B/,#;\xA4/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%3\xFD\"\"5&7\xFE.G &3\xFF\"\"5'7\u0100.; &3\u0101\"\"5$7\u0102./ &3\u0103\"\"5%7\u0104.# &;6/& 8!:\u0105! )"),
    peg$decode(";\xA5.# &;\xA0"),
    peg$decode("%3\u0106\"\"5(7\u0107/M#;</D$3\u0108\"\"5(7\u0109./ &3\u010A\"\"5(7\u010B.# &;6/#$+#)(#'#(\"'#&'#"),
    peg$decode("%;6/Y#$%;A/,#;6/#$+\")(\"'#&'#06*%;A/,#;6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%$;!/&#0#*;!&&&#/' 8!:\u010C!! )"),
    peg$decode("%;\xA9/& 8!:\u010D! )"),
    peg$decode("%;\xAA/k#;;/b$;\xAF/Y$$%;B/,#;\xB0/#$+\")(\"'#&'#06*%;B/,#;\xB0/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode(";\xAB.# &;\xAC"),
    peg$decode("3\u010E\"\"5$7\u010F.S &3\u0110\"\"5%7\u0111.G &3\u0112\"\"5%7\u0113.; &3\u0114\"\"5%7\u0115./ &3\u0116\"\"5+7\u0117.# &;\xAD"),
    peg$decode("3\u0118\"\"5'7\u0119./ &3\u011A\"\"5)7\u011B.# &;\xAD"),
    peg$decode(";6.# &;\xAE"),
    peg$decode("%3\u011C\"\"5\"7\u011D/,#;6/#$+\")(\"'#&'#"),
    peg$decode(";\xAD.# &;6"),
    peg$decode("%;6/5#;</,$;\xB1/#$+#)(#'#(\"'#&'#"),
    peg$decode(";6.# &;H"),
    peg$decode("%;\xB3/5#;./,$;\x90/#$+#)(#'#(\"'#&'#"),
    peg$decode("%$;!/&#0#*;!&&&#/' 8!:\u011E!! )"),
    peg$decode("%;\x9E/' 8!:\u011F!! )"),
    peg$decode("%;\xB6/^#$%;B/,#;\xA0/#$+\")(\"'#&'#06*%;B/,#;\xA0/#$+\")(\"'#&'#&/($8\":\u0120\"!!)(\"'#&'#"),
    peg$decode("%%;7/e#$%2J\"\"6J7K/,#;7/#$+\")(\"'#&'#0<*%2J\"\"6J7K/,#;7/#$+\")(\"'#&'#&/#$+\")(\"'#&'#/\"!&,)"),
    peg$decode("%;L.# &;\x99/]#$%;B/,#;\xB8/#$+\")(\"'#&'#06*%;B/,#;\xB8/#$+\")(\"'#&'#&/'$8\":\u0121\" )(\"'#&'#"),
    peg$decode(";\xB9.# &;\xA0"),
    peg$decode("%3\u0122\"\"5#7\u0123/:#;</1$;6/($8#:\u0124#! )(#'#(\"'#&'#"),
    peg$decode("%$;!/&#0#*;!&&&#/' 8!:\u0125!! )"),
    peg$decode("%;\x9E/' 8!:\u0126!! )"),
    peg$decode("%$;\x9A0#*;\x9A&/x#;@/o$;M/f$;?/]$$%;B/,#;\xA0/#$+\")(\"'#&'#06*%;B/,#;\xA0/#$+\")(\"'#&'#&/'$8%:\u0127% )(%'#($'#(#'#(\"'#&'#"),
    peg$decode(";\xBE"),
    peg$decode("%3\u0128\"\"5&7\u0129/k#;./b$;\xC1/Y$$%;A/,#;\xC1/#$+\")(\"'#&'#06*%;A/,#;\xC1/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#.# &;\xBF"),
    peg$decode("%;6/k#;./b$;\xC0/Y$$%;A/,#;\xC0/#$+\")(\"'#&'#06*%;A/,#;\xC0/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode("%;6/;#;</2$;6.# &;H/#$+#)(#'#(\"'#&'#"),
    peg$decode(";\xC2.G &;\xC4.A &;\xC6.; &;\xC8.5 &;\xC9./ &;\xCA.) &;\xCB.# &;\xC0"),
    peg$decode("%3\u012A\"\"5%7\u012B/5#;</,$;\xC3/#$+#)(#'#(\"'#&'#"),
    peg$decode("%;I/' 8!:\u012C!! )"),
    peg$decode("%3\u012D\"\"5&7\u012E/\x97#;</\x8E$;D/\x85$;\xC5/|$$%$;'/&#0#*;'&&&#/,#;\xC5/#$+\")(\"'#&'#0C*%$;'/&#0#*;'&&&#/,#;\xC5/#$+\")(\"'#&'#&/,$;E/#$+&)(&'#(%'#($'#(#'#(\"'#&'#"),
    peg$decode(";t.# &;w"),
    peg$decode("%3\u012F\"\"5%7\u0130/5#;</,$;\xC7/#$+#)(#'#(\"'#&'#"),
    peg$decode("%;I/' 8!:\u0131!! )"),
    peg$decode("%3\u0132\"\"5&7\u0133/:#;</1$;I/($8#:\u0134#! )(#'#(\"'#&'#"),
    peg$decode("%3\u0135\"\"5%7\u0136/]#;</T$%3\u0137\"\"5$7\u0138/& 8!:\u0139! ).4 &%3\u013A\"\"5%7\u013B/& 8!:\u013C! )/#$+#)(#'#(\"'#&'#"),
    peg$decode("%3\u013D\"\"5)7\u013E/R#;</I$3\u013F\"\"5#7\u0140./ &3\u0141\"\"5(7\u0142.# &;6/($8#:\u0143#! )(#'#(\"'#&'#"),
    peg$decode("%3\u0144\"\"5#7\u0145/\x93#;</\x8A$;D/\x81$%;\xCC/e#$%2D\"\"6D7E/,#;\xCC/#$+\")(\"'#&'#0<*%2D\"\"6D7E/,#;\xCC/#$+\")(\"'#&'#&/#$+\")(\"'#&'#/,$;E/#$+%)(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%3\u0146\"\"5(7\u0147./ &3\u0148\"\"5$7\u0149.# &;6/' 8!:\u014A!! )"),
    peg$decode("%;6/Y#$%;A/,#;6/#$+\")(\"'#&'#06*%;A/,#;6/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%;\xCF/G#;./>$;\xCF/5$;./,$;\x90/#$+%)(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%$;!/&#0#*;!&&&#/' 8!:\u014B!! )"),
    peg$decode("%;\xD1/]#$%;A/,#;\xD1/#$+\")(\"'#&'#06*%;A/,#;\xD1/#$+\")(\"'#&'#&/'$8\":\u014C\" )(\"'#&'#"),
    peg$decode("%;\x99/]#$%;B/,#;\xA0/#$+\")(\"'#&'#06*%;B/,#;\xA0/#$+\")(\"'#&'#&/'$8\":\u014D\" )(\"'#&'#"),
    peg$decode("%;L.O &;\x99.I &%;@.\" &\"/:#;t/1$;?.\" &\"/#$+#)(#'#(\"'#&'#/]#$%;B/,#;\xA0/#$+\")(\"'#&'#06*%;B/,#;\xA0/#$+\")(\"'#&'#&/'$8\":\u014E\" )(\"'#&'#"),
    peg$decode("%;\xD4/]#$%;B/,#;\xD5/#$+\")(\"'#&'#06*%;B/,#;\xD5/#$+\")(\"'#&'#&/'$8\":\u014F\" )(\"'#&'#"),
    peg$decode("%;\x96/& 8!:\u0150! )"),
    peg$decode("%3\u0151\"\"5(7\u0152/:#;</1$;6/($8#:\u0153#! )(#'#(\"'#&'#.g &%3\u0154\"\"5&7\u0155/:#;</1$;6/($8#:\u0156#! )(#'#(\"'#&'#.: &%3\u0157\"\"5*7\u0158/& 8!:\u0159! ).# &;\xA0"),
    peg$decode("%%;6/k#$%;A/2#;6/)$8\":\u015A\"\"$ )(\"'#&'#0<*%;A/2#;6/)$8\":\u015A\"\"$ )(\"'#&'#&/)$8\":\u015B\"\"! )(\"'#&'#.\" &\"/' 8!:\u015C!! )"),
    peg$decode("%;\xD8/Y#$%;A/,#;\xD8/#$+\")(\"'#&'#06*%;A/,#;\xD8/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%;\x99/Y#$%;B/,#;\xA0/#$+\")(\"'#&'#06*%;B/,#;\xA0/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%$;!/&#0#*;!&&&#/' 8!:\u015D!! )"),
    peg$decode("%;\xDB/Y#$%;B/,#;\xDC/#$+\")(\"'#&'#06*%;B/,#;\xDC/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%3\u015E\"\"5&7\u015F.; &3\u0160\"\"5'7\u0161./ &3\u0162\"\"5*7\u0163.# &;6/& 8!:\u0164! )"),
    peg$decode("%3\u0165\"\"5&7\u0166/:#;</1$;\xDD/($8#:\u0167#! )(#'#(\"'#&'#.} &%3\xF5\"\"5'7\xF6/:#;</1$;\x9E/($8#:\u0168#! )(#'#(\"'#&'#.P &%3\u0169\"\"5+7\u016A/:#;</1$;\x9E/($8#:\u016B#! )(#'#(\"'#&'#.# &;\xA0"),
    peg$decode("3\u016C\"\"5+7\u016D.k &3\u016E\"\"5)7\u016F._ &3\u0170\"\"5(7\u0171.S &3\u0172\"\"5'7\u0173.G &3\u0174\"\"5&7\u0175.; &3\u0176\"\"5*7\u0177./ &3\u0178\"\"5)7\u0179.# &;6"),
    peg$decode(";1.\" &\""),
    peg$decode("%%;6/k#$%;A/2#;6/)$8\":\u015A\"\"$ )(\"'#&'#0<*%;A/2#;6/)$8\":\u015A\"\"$ )(\"'#&'#&/)$8\":\u015B\"\"! )(\"'#&'#.\" &\"/' 8!:\u017A!! )"),
    peg$decode("%;L.# &;\x99/]#$%;B/,#;\xE1/#$+\")(\"'#&'#06*%;B/,#;\xE1/#$+\")(\"'#&'#&/'$8\":\u017B\" )(\"'#&'#"),
    peg$decode(";\xB9.# &;\xA0"),
    peg$decode("%;\xE3/Y#$%;A/,#;\xE3/#$+\")(\"'#&'#06*%;A/,#;\xE3/#$+\")(\"'#&'#&/#$+\")(\"'#&'#"),
    peg$decode("%;\xEA/k#;./b$;\xED/Y$$%;B/,#;\xE4/#$+\")(\"'#&'#06*%;B/,#;\xE4/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode(";\xE5.; &;\xE6.5 &;\xE7./ &;\xE8.) &;\xE9.# &;\xA0"),
    peg$decode("%3\u017C\"\"5#7\u017D/:#;</1$;\xF0/($8#:\u017E#! )(#'#(\"'#&'#"),
    peg$decode("%3\u017F\"\"5%7\u0180/:#;</1$;T/($8#:\u0181#! )(#'#(\"'#&'#"),
    peg$decode("%3\u0182\"\"5(7\u0183/F#;</=$;\\.) &;Y.# &;X/($8#:\u0184#! )(#'#(\"'#&'#"),
    peg$decode("%3\u0185\"\"5&7\u0186/:#;</1$;6/($8#:\u0187#! )(#'#(\"'#&'#"),
    peg$decode("%3\u0188\"\"5%7\u0189/A#;</8$$;!0#*;!&/($8#:\u018A#! )(#'#(\"'#&'#"),
    peg$decode("%;\xEB/G#;;/>$;6/5$;;/,$;\xEC/#$+%)(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%3\x92\"\"5#7\xD3.# &;6/' 8!:\u018B!! )"),
    peg$decode("%3\xB1\"\"5#7\u018C.G &3\xB3\"\"5#7\u018D.; &3\xB7\"\"5#7\u018E./ &3\xB5\"\"5$7\u018F.# &;6/' 8!:\u0190!! )"),
    peg$decode("%;\xEE/D#%;C/,#;\xEF/#$+\")(\"'#&'#.\" &\"/#$+\")(\"'#&'#"),
    peg$decode("%;U.) &;\\.# &;X/& 8!:\u0191! )"),
    peg$decode("%%;!.\" &\"/[#;!.\" &\"/M$;!.\" &\"/?$;!.\" &\"/1$;!.\" &\"/#$+%)(%'#($'#(#'#(\"'#&'#/' 8!:\u0192!! )"),
    peg$decode("%%;!/?#;!.\" &\"/1$;!.\" &\"/#$+#)(#'#(\"'#&'#/' 8!:\u0193!! )"),
    peg$decode(";\xBE"),
    peg$decode("%;\x9E/^#$%;B/,#;\xF3/#$+\")(\"'#&'#06*%;B/,#;\xF3/#$+\")(\"'#&'#&/($8\":\u0194\"!!)(\"'#&'#"),
    peg$decode(";\xF4.# &;\xA0"),
    peg$decode("%2\u0195\"\"6\u01957\u0196/L#;</C$2\u0197\"\"6\u01977\u0198.) &2\u0199\"\"6\u01997\u019A/($8#:\u019B#! )(#'#(\"'#&'#"),
    peg$decode("%;\x9E/^#$%;B/,#;\xA0/#$+\")(\"'#&'#06*%;B/,#;\xA0/#$+\")(\"'#&'#&/($8\":\u019C\"!!)(\"'#&'#"),
    peg$decode("%;6/5#;0/,$;\xF7/#$+#)(#'#(\"'#&'#"),
    peg$decode("$;2.) &;4.# &;.0/*;2.) &;4.# &;.&"),
    peg$decode("$;%0#*;%&"),
    peg$decode("%;\xFA/;#28\"\"6879/,$;\xFB/#$+#)(#'#(\"'#&'#"),
    peg$decode("%3\u019D\"\"5%7\u019E.) &3\u019F\"\"5$7\u01A0/' 8!:\u01A1!! )"),
    peg$decode("%;\xFC/J#%28\"\"6879/,#;^/#$+\")(\"'#&'#.\" &\"/#$+\")(\"'#&'#"),
    peg$decode("%;\\.) &;X.# &;\x82/' 8!:\u01A2!! )"),
    peg$decode(";\".S &;!.M &2F\"\"6F7G.A &2J\"\"6J7K.5 &2H\"\"6H7I.) &2N\"\"6N7O"),
    peg$decode("2L\"\"6L7M.\x95 &2B\"\"6B7C.\x89 &2<\"\"6<7=.} &2R\"\"6R7S.q &2T\"\"6T7U.e &2V\"\"6V7W.Y &2P\"\"6P7Q.M &2@\"\"6@7A.A &2D\"\"6D7E.5 &22\"\"6273.) &2>\"\"6>7?"),
    peg$decode("%;\u0100/b#28\"\"6879/S$;\xFB/J$%2\u01A3\"\"6\u01A37\u01A4/,#;\xEC/#$+\")(\"'#&'#.\" &\"/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode("%3\u01A5\"\"5%7\u01A6.) &3\u01A7\"\"5$7\u01A8/' 8!:\u01A1!! )"),
    peg$decode("%3\xB1\"\"5#7\xB2.6 &3\xB3\"\"5#7\xB4.* &$;+0#*;+&/' 8!:\u01A9!! )"),
    peg$decode("%;\u0104/\x87#2F\"\"6F7G/x$;\u0103/o$2F\"\"6F7G/`$;\u0103/W$2F\"\"6F7G/H$;\u0103/?$2F\"\"6F7G/0$;\u0105/'$8):\u01AA) )()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#"),
    peg$decode("%;#/>#;#/5$;#/,$;#/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode("%;\u0103/,#;\u0103/#$+\")(\"'#&'#"),
    peg$decode("%;\u0103/5#;\u0103/,$;\u0103/#$+#)(#'#(\"'#&'#"),
    peg$decode("%;q/T#$;m0#*;m&/D$%; /,#;\xF8/#$+\")(\"'#&'#.\" &\"/#$+#)(#'#(\"'#&'#"),
    peg$decode("%2\u01AB\"\"6\u01AB7\u01AC.) &2\u01AD\"\"6\u01AD7\u01AE/w#;0/n$;\u0108/e$$%;B/2#;\u0109.# &;\xA0/#$+\")(\"'#&'#0<*%;B/2#;\u0109.# &;\xA0/#$+\")(\"'#&'#&/#$+$)($'#(#'#(\"'#&'#"),
    peg$decode(";\x99.# &;L"),
    peg$decode("%2\u01AF\"\"6\u01AF7\u01B0/5#;</,$;\u010A/#$+#)(#'#(\"'#&'#"),
    peg$decode("%;D/S#;,/J$2:\"\"6:7;/;$;,.# &;T/,$;E/#$+%)(%'#($'#(#'#(\"'#&'#")
  ];

  let peg$currPos = 0;
  let peg$savedPos = 0;
  const peg$posDetailsCache = [{ line: 1, column: 1 }];
  let peg$maxFailPos = 0;
  let peg$maxFailExpected: Expectation[] = [];
  let peg$silentFails = 0;

  let peg$result;

  if (options.startRule !== undefined) {
    if (!(options.startRule in peg$startRuleIndices)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleIndex = peg$startRuleIndices[options.startRule];
  }

  function text(): string {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location(): IFileRange {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description: string, location1?: IFileRange) {
    location1 = location1 !== undefined
      ? location1
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location1
    );
  }

  function error(message: string, location1?: IFileRange) {
    location1 = location1 !== undefined
      ? location1
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location1);
  }

  function peg$literalExpectation(text1: string, ignoreCase: boolean): ILiteralExpectation {
    return { type: "literal", text: text1, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts: IClassParts, inverted: boolean, ignoreCase: boolean): IClassExpectation {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation(): IAnyExpectation {
    return { type: "any" };
  }

  function peg$endExpectation(): IEndExpectation {
    return { type: "end" };
  }

  function peg$otherExpectation(description: string): IOtherExpectation {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos: number) {
    let details = peg$posDetailsCache[pos];
    let p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos: number, endPos: number): IFileRange {
    const startPosDetails = peg$computePosDetails(startPos);
    const endPosDetails = peg$computePosDetails(endPos);

    return {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected1: Expectation) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected1);
  }

  function peg$buildSimpleError(message: string, location1: IFileRange) {
    return new SyntaxError(message, [], "", location1);
  }

  function peg$buildStructuredError(expected1: Expectation[], found: string | null, location1: IFileRange) {
    return new SyntaxError(
      SyntaxError.buildMessage(expected1, found),
      expected1,
      found,
      location1
    );
  }

  function peg$decode(s: string): number[] {
    return s.split("").map((ch) =>  ch.charCodeAt(0) - 32 );
  }

  function peg$parseRule(index: number): any {
    const bc = peg$bytecode[index];
    let ip = 0;
    const ips: any[] = [];
    let end = bc.length;
    const ends: any[] = [];
    const stack: any[] = [];
    let params;

    while (true) {
      while (ip < end) {
        switch (bc[ip]) {
          case 0:
            stack.push(peg$consts[bc[ip + 1]]);
            ip += 2;
            break;

          case 1:
            stack.push(undefined);
            ip++;
            break;

          case 2:
            stack.push(null);
            ip++;
            break;

          case 3:
            stack.push(peg$FAILED);
            ip++;
            break;

          case 4:
            stack.push([]);
            ip++;
            break;

          case 5:
            stack.push(peg$currPos);
            ip++;
            break;

          case 6:
            stack.pop();
            ip++;
            break;

          case 7:
            peg$currPos = stack.pop();
            ip++;
            break;

          case 8:
            stack.length -= bc[ip + 1];
            ip += 2;
            break;

          case 9:
            stack.splice(-2, 1);
            ip++;
            break;

          case 10:
            stack[stack.length - 2].push(stack.pop());
            ip++;
            break;

          case 11:
            stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
            ip += 2;
            break;

          case 12:
            stack.push(input.substring(stack.pop(), peg$currPos));
            ip++;
            break;

          case 13:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (stack[stack.length - 1]) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 14:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (stack[stack.length - 1] === peg$FAILED) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 15:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (stack[stack.length - 1] !== peg$FAILED) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 16:
            if (stack[stack.length - 1] !== peg$FAILED) {
              ends.push(end);
              ips.push(ip);

              end = ip + 2 + bc[ip + 1];
              ip += 2;
            } else {
              ip += 2 + bc[ip + 1];
            }

            break;

          case 17:
            ends.push(end);
            ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

            if (input.length > peg$currPos) {
              end = ip + 3 + bc[ip + 1];
              ip += 3;
            } else {
              end = ip + 3 + bc[ip + 1] + bc[ip + 2];
              ip += 3 + bc[ip + 1];
            }

            break;

          case 18:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

            if (input.substr(peg$currPos, (peg$consts[bc[ip + 1]] as string).length) === peg$consts[bc[ip + 1]]) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }

            break;

          case 19:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

            if (input.substr(peg$currPos, (peg$consts[bc[ip + 1]] as string).length).toLowerCase() === peg$consts[bc[ip + 1]]) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }

            break;

          case 20:
            ends.push(end);
            ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

            if ((peg$consts[bc[ip + 1]] as RegExp).test(input.charAt(peg$currPos))) {
              end = ip + 4 + bc[ip + 2];
              ip += 4;
            } else {
              end = ip + 4 + bc[ip + 2] + bc[ip + 3];
              ip += 4 + bc[ip + 2];
            }

            break;

          case 21:
            stack.push(input.substr(peg$currPos, bc[ip + 1]));
            peg$currPos += bc[ip + 1];
            ip += 2;
            break;

          case 22:
            stack.push(peg$consts[bc[ip + 1]]);
            peg$currPos += (peg$consts[bc[ip + 1]] as string).length;
            ip += 2;
            break;

          case 23:
            stack.push(peg$FAILED);
            if (peg$silentFails === 0) {
              peg$fail(peg$consts[bc[ip + 1]] as ILiteralExpectation);
            }
            ip += 2;
            break;

          case 24:
            peg$savedPos = stack[stack.length - 1 - bc[ip + 1]];
            ip += 2;
            break;

          case 25:
            peg$savedPos = peg$currPos;
            ip++;
            break;

          case 26:
            params = bc.slice(ip + 4, ip + 4 + bc[ip + 3])
              .map(function(p) { return stack[stack.length - 1 - p]; });

            stack.splice(
              stack.length - bc[ip + 2],
              bc[ip + 2],
              (peg$consts[bc[ip + 1]] as ((...args: any[]) => any)).apply(null, params)
            );

            ip += 4 + bc[ip + 3];
            break;

          case 27:
            stack.push(peg$parseRule(bc[ip + 1]));
            ip += 2;
            break;

          case 28:
            peg$silentFails++;
            ip++;
            break;

          case 29:
            peg$silentFails--;
            ip++;
            break;

          default:
            throw new Error("Invalid opcode: " + bc[ip] + ".");
        }
      }

      if (ends.length > 0) {
        end = ends.pop();
        ip = ips.pop();
      } else {
        break;
      }
    }

    return stack[0];
  }


    options.data = {}; // Object to which header attributes will be assigned during parsing

    function list(head: string, tail: Array<string>) {
      return [head].concat(tail);
    }


  peg$result = peg$parseRule(peg$startRuleIndex);

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

export interface IParseOptions {
  filename?: string;
  startRule?: string;
  tracer?: any;
  [key: string]: any;
}
export type ParseFunction = (input: string, options?: IParseOptions) => any;
export const parse: ParseFunction = peg$parse;
